import { useState } from 'react';
import { LayoutModule } from '../../../layout/modules';
import { RedirectPqrFilters } from './filters';
import { RedirectPqrList } from './list';
import { RedirectParams as Redirect } from '../../../../shared/types/redirectParams';
import { REDIRECTNEW } from '../../../../routes/paths';
import {
    isOnlyViewProfile,
    isOperativeProfile,
} from '../../../../shared/types/profiles';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';

export const RedirectParams = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [filters, setFilters] = useState<Redirect>();

    return (
        <>
            <LayoutModule
                title="Búsqueda de personas redirección PQR"
                showTitle
                {...(!isOnlyViewProfile(type) &&
                    !isOperativeProfile(type) && { createPath: REDIRECTNEW })}
            >
                <RedirectPqrFilters
                    onFilter={(filters) => setFilters(filters)}
                />
            </LayoutModule>
            <RedirectPqrList filters={filters} />
        </>
    );
};
